import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "iconExpand", "iconCollapse", "button"]
  static values = { expanded: { type: Boolean, default: false } }

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    if (this.hasContentTarget) {
      this.contentTarget.hidden = !this.expandedValue
    }

    // Update aria-expanded on button for accessibility
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", this.expandedValue)
    }

    // Toggle hidden class for icon states
    this.iconExpandTargets.forEach(el => {
      el.classList.toggle("expand-button__state--hidden", this.expandedValue)
    })
    this.iconCollapseTargets.forEach(el => {
      el.classList.toggle("expand-button__state--hidden", !this.expandedValue)
    })
  }
}
